import { useEffect } from 'react';
import { useOnScreen } from '@hooks/useOnScreen';
import { Integrations } from '@static/js/types';

const analytics = require('/static/js/joy');

/**
 * Used to track telemetry event with amplitude on user interact on specified section
 * @param sectionRef - section Ref
 * @param elementId - section Id
 * @param rootMargin - Allows to specify margin around the section that intersects with the observed target.
 * @param threshold - 0.5 = 50%. Percentage of the target's visibility in the root the observer's callback should be executed.
 * @returns void
 */
export const useOnScreenTelemetry = (
  sectionRef: React.RefObject<Element | null>,
  elementId: string,
  rootMargin = '0px',
  threshold = 0.5
) => {
  const isVisible = useOnScreen(sectionRef, rootMargin, true, threshold);
  useEffect(() => {
    if (isVisible) {
      analytics.segment.sendTelemetryEvent('newmarcom.sectionViewed', { elementId }, true, {
        integrations: { [Integrations.Amplitude]: true },
      });
    }
  }, [sectionRef, isVisible, elementId]);
};
